import React,{useState} from 'react'
import classes from './Subscribe.module.css'
import img_logo from '../Assets/high_logo.png'
import Select from 'react-select';
import Cookies from 'js-cookie'
import axios from 'axios'
import {useNavigate} from 'react-router-dom'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { base_url } from '../Services/api';

const Subscribe = () => {


  function generateUniqueAlphabetId(length = 22) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }

    return result;
}


    const [number,setNumber] = useState('');
    const [headersNumber,setHeadersNumber] = useState('');
    const [loading,setLoading] = useState(false);

    const navigate = useNavigate();

    const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' })

    const urlParams = new URLSearchParams(window.location.search);
  const msisdn = urlParams.get('msisdn');
  const ExtId = urlParams.get('extId') || generateUniqueAlphabetId();

    Cookies.set('extId',ExtId);



     const options = [
    { value: 'daily', label: 'Tous les jours/100 FCFA' },
    { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
    { value: 'monthly', label: 'Mensuelle/500 FCFA' },
  ];

  
    // const handle=async(e)=>{
    //   e.preventDefault();
    //   setLoading(true)
    //   // console.log('handleClicked')
    //   try{
       
    //         Cookies.set('number',number)
    //         Cookies.set('pack',selectedOption.value)
  
    //         if(!number){
    //           toast.warn("Veuillez d'abord entrer le numéro!!")
    //         }
  
    //         const res = await axios.post(`${base_url}/send-otp?msisdn=${number}`);
    //         console.log(res.data);
  
    //         if(res.status == 200){
    //           toast.success('OTP envoyé avec succès!!')
    //           setTimeout(()=>{
    //             navigate(`/otp-validation?id=${res.data}`)
    //           },1000)
    //         }  
    //   }
    //   catch(err){
    //     console.log(err)
    //     toast.error(err?.response?.data)
    //   }
    //   setLoading(false)
    // }

//     const handle = async (e) => {
//   e.preventDefault();
//   setLoading(true);
//   try {
//     Cookies.set('number', number);
//     Cookies.set('pack', selectedOption.value);

//     if (!number) {
//       toast.warn("Veuillez d'abord entrer le numéro!!");
//       setLoading(false);
//       return;
//     }

//     const res = await axios.post(`${base_url}/api/v1/send`, {
//       msisdn: number,
//       serviceName: 'HighFive', // replace with your actual serviceName
//     });

//     console.log(res.data);

//     if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {
//       toast.success('OTP envoyé avec succès!!');
//       setTimeout(() => {
//         navigate(`/otp-validation?id=${res.data?.data?.id ?? ''}`);
//       }, 1000);
//     } else {
//       toast.error(res.data?.message || "Une erreur s'est produite");
//     }
//   } catch (err) {
//     console.log(err);
//     toast.error(err?.response?.data?.message || "Une erreur s'est produite");
//   }
//   setLoading(false);
// };



const handle = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    Cookies.set('number', number);
    Cookies.set('pack', selectedOption.value);

    if (!number) {
      toast.warn("Veuillez d'abord entrer le numéro!!");
      setLoading(false);
      return;
    }

    const res = await axios.post(`${base_url}/api/v1/send`, {
      msisdn: number,
      serviceName: 'HighFives', // replace with your actual serviceName
    });

    console.log(res.data);

    if (res.data?.statusCode === 200 || res.data?.code === 'SUCCESS') {
      toast.success('OTP envoyé avec succès!!');
      setTimeout(() => {
        navigate(`/otp-validation?id=${res.data?.data?.id ?? ''}`);
      }, 1000);
    } else {
      toast.error(res.data?.message || "Une erreur s'est produite");
    }
  } catch (err) {
    console.log(err);
    const status = err?.response?.status;
    toast.error(err?.response?.data?.message || "Une erreur s'est produite");

    if (status === 400 || status === 500) {
      navigate('/subscribe');
    }
  }
  setLoading(false);
};

  return (
    <div className={classes.container}>
    {/* <ToastContainer/> */}
    <div className={classes.sub_container}>
    <form onSubmit={handle} className={classes.form} >
    <img src={img_logo} alt="" />
        <p className="text-end text-md font-bold ml-24" >-Service fourni par Panz</p>

    <div className={classes.welcome}>
    <div className='w-[100%] md:w-[80%] text-center'>
      <p className={classes.welcome_text}>Bienvenue à HighFive Games</p>
    
 
    <p className={classes.desc} >HighFive est un portail de jeux proposant des jeux amusants et captivants de différents genres pour les joueurs de tous niveaux.</p>
    </div>
    </div>
   <div className={classes.inputs}>
   <div className={classes.input}>
    <h1 className='mt-4 text-white text-xl font-bold'>{headersNumber == ''?'Entrez votre numéro':'Votre numéro'}</h1>
          <input type="text" class="bg-gray-50 focus:outline-none text-gray-900 mt-2 text-sm py-3 block w-full p-2.5  dark:border-gray-600  dark:gray-900"

            placeholder='Entrez votre numéro de téléphone : eg 812xxxxxx'
            id="phoneInput"
            name="ani"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            required />
            </div>
            <div className={classes.input}>
            <p className='text-white pt-2 text-lg font-semibold'>Type de paquet</p>
          <Select
        defaultValue={selectedOption}
        onChange={setSelectedOption}
        options={options}
        className='w-full'
      />
            </div>

            <button
            disabled={loading}
            type="submit"
            class=" w-full text-white mt-2 bg-[#0D6EFD] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-7 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
            {loading ? "Chargement..." : "S'abonner"}
          </button>
             <p
  onClick={() => navigate('/tnc')}
  className="text-white text-center mt-4 mb-2 underline cursor-pointer"
>
Conditions générales
</p>
   </div>
   <div className='w-[100%] md:w-[80%] text-center'>
    <span className='text-xs font-semibold w-full text-center' >• Désinscription gratuite à tout moment : composez #303#10#.</span>
    <br/>
        <span className='text-xs font-semibold w-full text-center' >• Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
        </div>
    </form>
    
    </div>
    </div>
  )
}

export default Subscribe
